<template>
  <div class="container">
    <h1>Available keys</h1>
    <game-list/>
  </div>
</template>

<script>
import GameList from "./GameList.vue";

export default {
  name: "app",
  components: {
    GameList
  }
};
</script>